<template>
     <div>
      <!-- style="box-shadow: 0px 10px 20px rgb(0 0 0 / 5%)" -->
    <!-- <header class="lmy-header lmy-header-w">
      <i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
      去兑换
    </header> -->
    <div class="infinite-loading-containers" v-if="!reserveInfo">
      <i class="loading-defaults"></i>
    </div>
    <div class="lmy-purchase" v-if="reserveInfo">
      <div class="lmy-pur-content">
        <div class="rush-text">{{reserveInfo.ProductName}}</div>
        <div class="content-body">预约码：{{reserveInfo.Code}}</div>
        <div v-if="reserveInfo.TimeLimitTypeName" style="margin-top: 0.1rem;margin-left: 5em;color:#eb3941;font-weight:bold;position: relative;">
          <span style="position: absolute;top: 0;left: -5em;">适用限制：</span>
                {{reserveInfo.TimeLimitTypeName}}
        </div>
      </div>
     
      <div class="date-picker-box" v-if="dailyData&&dailyData.length>0">
        <div class="dpb-title">
          <span @click="minus"><i class="iconfont icon-yuyin"></i></span>
          <span>{{getMonths(number)}}</span>
          <span @click="plus" style="transform: rotate(180deg);"><i class="iconfont icon-yuyin"></i></span>
        </div>
        <div class="dpb-week">
          <table>
            <thead>
              <tr>
                <th>日</th>
                <th>一</th>
                <th>二</th>
                <th>三</th>
                <th>四</th>
                <th>五</th>
                <th>六</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="dpb-week-days">
          <div class="dpbwd-table" v-for="(item,index) in data" v-if="index==number">
            <div class="dpbwd-table-items">
              <table class="dpbwd-table-items-table">
                <tbody >
                  <tr v-for="week in item">	
                    <td :class="day.isActive?'active':(day.isInRange?'range':day.isDisable?'disable':'')" v-for="(day,i) in week" @click="select(day)">
                      <div :class="i==0||i==6?'weekcolor page-table-item':'page-table-item'">
                        <div class="page-table-text">
                          {{day.day}}
                        </div>
                        <div class="page-table-note" v-if="day.item">{{day.isDisable?'约满':'可约'}}</div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="hanleDate" v-if="hDate">您选择的出发日期为：{{hDate}}</div>
        <div v-if="!AllowCancel" style="color:#eb3941;">此订单即订即保，订单一经确认，不可取消更改</div>
        <div v-if="AllowCancel&&CancelDate" style="color:#eb3941;">最后可取消时间为：{{CancelDate}}</div>
      </div>
      <div class="date-picker-box" v-if="!dailyData&&!isDailyShow" style="color:#eb3941; text-align:center;font-weight:bold;">日期暂已约满</div>
      <div class="date-picker-box" v-if="!dailyData&&isDailyShow">
        <div class="infinite-loading-containers">
          <i class="loading-defaults"></i>
        </div>
      </div>
      <div class="lmy-reservation-order" style="padding:0;padding-top:.2rem">
         <div class="people-info">
                <!-- <div class="info-title" style="text-align: center;font-weight: bold;">
                    填写订单信息
                </div> -->
                <!-- <div class="room-people-toast"> ' * ' 符号为必填信息</div> -->
                <div>
                    <div class="info-title" style="margin-top:0.3rem;color:#c8a973">旅客信息</div>
                    <div class="info-item">
                        <div class="item-label"><span style="color:red">* </span>姓名</div>
                        <div class="item-body">
                            <input type="text" placeholder="需与证件保持一致" v-model="guestItem.CnName">
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="item-label"><span style="color:red">* </span>手机号</div>
                        <div class="item-body">
                            <input type="text" placeholder="接收短信消息" v-model="guestItem.Phone">
                        </div>
                    </div>
                    <div class="info-item" v-if="reserveInfo.IsIdcard">
                        <div class="item-label"><span style="color:red">* </span>身份证</div>
                        <div class="item-body">
                            <input type="text" placeholder="填写身份证号码" v-model="guestItem.CardNumber">
                        </div>
                    </div>
                </div>
                <div class="info-item">
                  <div class="item-label">备注</div>
                  <div class="item-body">
                    <input type="text" placeholder="请输入" v-model="SpecialRequest">
                  </div>
                </div>
            </div>
      </div>

      <div class="content-head">特别说明</div>
      <div class="content-body">预约后订单状态为“等待确认”状态，需等待酒店确认。有可能出现确认失败情况，若确认失败预约码状态会自动变更为“未预约”。</div>
      <div style="margin-top: 0.6rem;" v-for="N,index in reserveInfo.Notice" :key="index" v-if="index=='发票说明'">
          <div class="content-head">{{index}}</div>
          <div class="content-body" v-html="N"></div>
      </div>
      
      <!-- <div class="content-head" style="margin-top: 0.6rem;">发票说明</div>
      <div class="content-body">发票由「捷银国旅」开具，支持普通发票，开票内容：旅游服务*旅游服务费。默认支持电子普票，纸质普票邮寄方式为快递到付！</div> -->
      <div class="submit" @click="book">提交</div>

      <div class="book-comfirming" v-if="isSubmit">
        <div class='f-modal' >
          <div class='f-modal-head'>提示</div>
          <div class='f-modal-body'>
            <p>正在提交预约，请稍候...</p>
          </div>
        </div>
      </div>
    </div>  
  </div>

</template>
<script>
export default {
  name: "dailyData",

  data() {
    return {
      seed: '',
      ts:'',
      orderInfo:'',
      data: [],
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      begin: "",
      end: "",
      hDate: "",
      dailyData:'',
      number:0,
      guestItem: {
        CnName: "",
        CardNumber: "",
        Phone: "",
      },
      SpecialRequest:'',
      isSubmit: false,
      reserveInfo:'',
      Token:'',
      Price:'',
      OrderNO:'',
      AllowCancel:false,
      CancelDate:'',
      isDailyShow:false
    };
  },
  methods: {
    //获取套餐信息
    getReserveInfo() {
      var that = this;
      var params = {
        seed: that.seed,
        ts: that.ts,
        orderInfo: that.orderInfo,
      };
      
      that
        .postRequest({
          url: that.Api.getGDReserveInfo,
          params: JSON.stringify(params)
        })
        .then(res => {
          if (res && res.IsSuccess) {
            that.reserveInfo = res.Result
            that.getPackageDaily()
          } else {
            this.error({ title: "提示", content: '非法信息！' });
          }
        });
    },
    //获取价格日历
    getPackageDaily() {
      var that = this;
      var start = ''
      if(that.getDays(that.dateToYMDline(that.reserveInfo.StartActiveDate),that.getDate(0))>0){
        start = that.getDate(0)
      }else{
        start = that.dateToYMDline(that.oreserveInf.StartActiveDate)
      }
      var params = {
        HotelID: JSON.stringify(that.reserveInfo.HotelId),
        RoomID: JSON.stringify(that.reserveInfo.RoomId),
        RPID: JSON.stringify(that.reserveInfo.RpId),
        RateID: JSON.stringify(that.reserveInfo.RateId),
        ProductID: JSON.stringify(that.reserveInfo.ProductId),
        SKUID: JSON.stringify(that.reserveInfo.SkuID),
        Start: start,
        End: that.dateToYMDline(that.reserveInfo.EndActiveDate),
        seed: that.seed,
        ts: that.ts,
        orderInfo: that.orderInfo,
        NeedIDCard: that.reserveInfo.IsIdcard,
      };
      that.isDailyShow = true
      that
        .postRequest({
          url: that.Api.getGDPrices,
          params: JSON.stringify(params)
        })
        .then(res => {
          that.isDailyShow = false
          if (res && res.IsSuccess) {
            var result = res.Result.reverse();
            var arr = [];
            result.forEach(item => {
              if(item.Status=='Open'){
                if(item.IsAskRoom||(!item.IsAskRoom&&item.Stock>0)){
                  item.isBook=true
                }else{
                  item.isBook=false
                }
              }else {
                item.isBook=false
              }
              item.Date = item.Date.slice(0, 10);
              arr.push(item);
            });
            var index = 0
            var flag=true
            for(var i = 0;i<arr.length;i++){
              if(arr[i].isBook&&flag){
                index = i
                flag = false
              }
            }
            that.dailyData = arr;
            that.hDate = arr[index].Date
            that.Token = arr[index].Token
            that.Price = arr[index].Price
            that.AllowCancel = arr[index].AllowCancel
            that.CancelDate = arr[index].CancelDate
            // 计算月份差
            var dt1=that.hDate
            var dt2=that.getDate(0)
            dt1=dt1.split('-')
            dt1=parseInt(dt1[0])*12+parseInt(dt1[1])
            dt2=dt2.split('-')
            dt2=parseInt(dt2[0])*12+parseInt(dt2[1])
            var num=Math.abs(dt1-dt2)
            that.number = num
            var length = that.dailyData.length - 1;
            that.begin = that.dailyData[0].Date;
            that.end = that.dailyData[length].Date;
            that.tableDate();
          } else {
            this.error({ title: "提示", content: res.Msg||'每日详情获取失败。' });
          }
        });
    },

    book() {
      var that = this;
      var SFreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if((!that.hDate)||(!that.Token)){
        that.$alert("您尚未选择出行日期!");
        return;
      }
      if (that.reserveInfo.IsIdcard) {
          if (
            !(that.guestItem.CnName && that.guestItem.Phone && that.guestItem.CardNumber)
          ) {
            that.$alert("您有未填写的信息，请继续填写");
            return;
          } else if (!that.isPhoneAvailable(that.guestItem.Phone)) {
            that.$alert("您的手机格式有误，请您核对");
            return;
          } else if (!SFreg.test(that.guestItem.CardNumber)) {
            that.$alert("您的身份证格式有误，请您核对");
            return;
          }
        } else {
          if (!(that.guestItem.CnName && that.guestItem.Phone)) {
            that.$alert("您有未填写的信息，请继续填写");
            return;
          } else if (!that.isPhoneAvailable(that.guestItem.Phone)) {
            that.$alert("您的手机格式有误，请您核对");
            return;
          }
        }
        that.guestItem.NeedIDCard = that.reserveInfo.IsIdcard
      
      var param = {
        Token: that.Token,
        Code:that.reserveInfo.Code,
        CheckIn:that.hDate,
        QGOrderNo:that.reserveInfo.QGOrderNo,
        QGId:JSON.stringify(that.reserveInfo.QGId),
        Guests: [that.guestItem],
        SpecialRequest: that.SpecialRequest,
        seed: that.seed,
        ts: that.ts,
        orderInfo: that.orderInfo,
        ReceiverName: "",
        ReceiverPhone: that.guestItem.Phone,
        ReceiverEmail: "",
      };
      that.isSubmit = true;
      that
        .postRequest({
          url: that.Api.getGDReserve,
          params: JSON.stringify(param)
        })
        .then(res => {
          that.isSubmit = false;
          if (res && res.IsSuccess) {
            this.error({ title: "提示", content: '您已成功预约!请于 '+that.hDate+" 出行！" });
          } else if (!res.IsSuccess) {
            this.error({ title: "提示", content: '预约失败' });
          }
        });
    },
    isPhoneAvailable(phone) {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(phone)) {
        return false;
      } else {
        return true;
      }
    },

    //减1
    minus() {
      if (this.number == 0)return;
      this.number -= 1;
    },
    //加1
    plus() {
      if (this.number >= 5)return;
      this.number += 1;
    },

    //选中日期
    select(day) {
      if (!day.isInRange) return;
      this.hDate = day.item.Date
      this.Token = day.item.Token
      this.Price = day.item.Price
      this.tableDate();
    },
    //查看是否是已经选中的日期区间中
    isInRange(day) {
      if (!day) return;
      var s1 = new Date(this.begin).getTime();
      var s2 = new Date(this.end).getTime();
      var s = new Date(day.year + "-" + day.month + "-" + day.day).getTime();
      if (s <= s2 && s >= s1) return true;
    },
    //获取天数差
    getDaysSize(s1, s2) {
      var s1 = new Date(s1);
      var s2 = new Date(s2);

      var days = s2.getTime() - s1.getTime();
      var time = parseInt(days / (1000 * 60 * 60 * 24));
      return time;
    },
    //获取周几
    getWeekday(date) {
      var nowDate = new Date();
      var days = this.getDaysSize(nowDate, date);
      var mydate = new Date(date);
      var myday = mydate.getDay(); //注:0-6对应为星期日到星期六
      return myday;
    },

    //将数据格式化表格日期格式
    monthDate(year, month) {
      var that = this
      //或取当前月份最后一天的日期
      var day = new Date(year, month, 0);
      var lastDay = day.getDate();
      //计算当前月份第一天是星期几
      var weekday = that.getWeekday(year + "-" + month + "-01");
      //定义存放当前月份的数组
      var data = [];
      //定义日期表格数组
      var result = [];
      //计算出当前月份每一天到数组中
      for (var day = 1; day <= lastDay; day++) {
        var day = day < 10 ? "0" + day : day;
        var date = year + "-" + month + "-" + day;
        var flag = true;
        var isInRange, isDisable, isActive;
        that.dailyData.forEach(item => {
          if (date == item.Date) {
            flag = false
            if(date == that.hDate) {
              isActive = true
            }else {
              isActive = false;
            }
            if(item.isBook){
              isInRange = true;
              isDisable = false;
            }else {
              isInRange = false;
              isDisable = true;
              isActive = false;
            }
            data.push({
              day,
              month,
              year,
              isActive,
              isInRange,
              isDisable,
              item
            });
          }
        });
        if (flag) {
            isActive = false;
            isInRange = false;
            isDisable = true;
            data.push({
              day,
              month,
              year,
              isActive,
              isInRange,
              isDisable,
            });
        }
      }

      //补全日期前几天
      for (var i = 0; i < weekday; i++) {
        data.unshift("");
      }
      //切成6行
      for (var i = 0, len = data.length; i < len; i += 7) {
        result.push(data.slice(i, i + 7));
      }
      //补全日期后几天
      var length = result[result.length - 1].length;
      if (length < 7) {
        for (var i = 0; i < 7 - length; i++) {
          result[result.length - 1].push("");
        }
      }
      return result;
    },
    //初始化表格数据
    tableDate() {
      var monthLength = 6;
      var data = [];
      // var date = new Date();
      var year = this.year; //获取完整的年份(4位)
      var month = this.month; //获取当前月份
      // console.log(year,month,monthLength)

      for (var i = 0; i < monthLength; i++) {
        var y = month + i > 12 ? year + 1 : year;
        var m = month + i > 12 ? month + i - 12 : month + i;
        // console.log(y,m)
        var re = this.monthDate(y, m < 10 ? "0" + m : m);
        data.push(re);
      }
      this.data = data;
    },
  },
  mounted(){
    this.seed = this.$route.query.seed;
    this.orderInfo = this.$route.query.orderInfo;
    this.ts = this.$route.query.ts;
    // this.seed = "vlTxnTKpAKpOSIYF";
    // this.orderInfo = "DSmDEAREvMMzZl5y0VVBsjsPGJDNsxFadqP6Kdd%2ftV6agO1HouHJ9ylkBRFFG6Qk";
    // this.ts = "1670837611642";
    if(!this.seed||!this.orderInfo||!this.ts){
      this.error({ title: "提示", content: '缺少重要参数，请重新进入！' });
    }else{
      this.getReserveInfo()
    }
    
  }
};
</script>
<style scoped>
.date-picker-box {
  padding-top: 10px;
  /* padding-bottom: 30px; */
}
.weekcolor {
  color: #fb8800 !important;
}
.active .weekcolor {
  color: #fff !important;
}
.dpb-title {
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: #edeef2;
    font-size: 15px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.5rem;
}

.dpb-title i{
  color: #2391ff;
  padding: 5px;
  background-color: #fff;
}

.closeBtn {
    position: absolute;
    width: 0.5rem;
    right: 0.3rem;
    top: 50%;
    transform: translateY(-50%);
}
.dpb-week > table {
  background: #fff;
  font-size: 13px;
  width: 100%;
  border-collapse: separate;
  table-layout: fixed;
}
.dpb-week > table > thead > tr > th {
  height: 30px;
  text-align: center;
  font-weight: 400;
  /* border-bottom: 1px solid #e0e0e0; */
  width: 14.28571%;
  vertical-align: middle;
}
.dpb-week-days {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.dpbwd-table-month {
  height: 30px;
  display: -webkit-box;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  font-size: 15px;
  font-weight: 700;
  background: hsla(210, 8%, 95%, 0.9);
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;
  /* border-bottom: 1px solid #e0e0e0; */
}
.page-table-item {
  box-sizing: border-box;
  position: relative;
  /*display: -webkit-box;*/
  -webkit-box-orient: vertical;
  -webkit-box-align: center;
  -webkit-box-pack: end;
}
.page-table-text {
  font-size: 13px;
  color: #000;
  height: 15px;
  line-height: 15px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.page-table-note {
  color: #fb8800;
  font-size: 12px;
  height: 15px;
  line-height: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-style: inherit;
}
.page-table-note,
.page-table-text {
  display: block;
  width: 100%;
  text-align: center;
}

.active .page-table-note,
.active .page-table-text {
  color: #fff;
}
.dpbwd-table-items-table > tbody > tr > td.disable .page-table-text,
.dpbwd-table-items-table > tbody > tr > td.disable .page-table-note {
  color: #ccc !important;
  background: none !important;
}
.dpbwd-table-items-table > tbody > tr > td.range {
  background: #e8f4ff;
  /* border-bottom-color: #e8f4ff !important; */
}
.dpbwd-table-items-table > tbody > tr > td.active {
  color: #fff;
  background: #2391ff;
  /* border-bottom-color: #2391ff !important; */
}
.dpbwd-table-items-table > tbody > tr > td.disable {
  background: #fff !important;
  /* border-bottom-color: #e0e0e0 !important; */
}
.dpbwd-table-items-table > tbody > tr > td {
  height: 50px;
  text-align: center;
  width: 14.28571%;
  position: relative;
  background-color: #f8f8f8;
  /* border-bottom: 1px solid #e0e0e0; */
}
.dpbwd-table-items-table {
  width: 100%;
  border-collapse: separate;
  table-layout: fixed;
}

.lmy-purchase {
  padding-top: 0.5rem;
}

.hanleDate{
  margin-top: 20px;
  margin-bottom: 10px;
}
.submit {
    font-size: 16px;
    color: #fff;
    text-align: center;
    padding: 15px 0;
    margin-top: 30px;
    border-radius: 50px;
    background-color: #c8a973;
}

</style>



// WEBPACK FOOTER //
// src/components/GDmap/dailyData.vue